import { CommonModule } from "@angular/common";
import { Component, inject, Input } from "@angular/core";
import { PortalUserService } from "@aifs-shared/portal/portal-user-service";

@Component({
    selector: 'app-news-feed',
    templateUrl: './news-feed.component.html',
    styleUrls: ['./news-feed.component.scss'],
    imports: [CommonModule],
    standalone: true,
})
export class NewsFeedComponent {
    userService = inject(PortalUserService);

    ngOnInit() {
        // TODO(IAN): Get feed from injected service

        this.news = [
            new NewsItem(1, '2nd February', 'Last weeks recruitment fairs saw a record number of placements. Thank you all for your hard work. Remember to submit your expenses by Friday!'),
            new NewsItem(2, '12 January', 'System updated on 12th January. Full release notes can be found <a href="#">here</a>.')
        ];

    }


    news: NewsItem[] = [];
}

// TODO(IAN): Move to a specific news service?
// or is this part of the portal user service (more likely atm)
export class NewsItem {
    id: number;
    displayDate: string;
    message: string;

    constructor(id: number, date: string, message: string) {
        this.id = id;
        this.displayDate = date;
        this.message = message;
    }
}